<template>
    <div class="paperpile_rg_section_wrp">
        <div class="paperpile_content_wrp">
            <div class="paperpile_content_header">
                <div class="row align-items-center">
                    <div class="col-sm">
                        <h2 class="rfiles_main_heading"><button type="button" class="btn back_btn" tapable
                                @click="$router.go(-1)">
                                <i class="fa fa-chevron-left" aria-hidden="true"></i>
                            </button>Research Group</h2>
                    </div>
                    <div class="col-sm-auto ml-sm-auto mt-2 mt-sm-0">
                        <ul class="rfiles_header_right_side">
                            <li v-if="selfUserInfo">
                                <template v-if="selfUserInfo.pro_payment || selfUserInfo.auto_payment">
                                    <button class="btn btn-primary" v-on:click="openPopupOfAddResearchGroup()">Create
                                        Research
                                        Group</button>
                                </template>
                                <template v-else>
                                    <button class="btn gray_out_global_btn"
                                        @click="accessFeaturesOfPackagemethod">Create Research
                                        Group</button>
                                </template>
                            </li>
                        </ul>
                    </div>
                </div>
            </div>
            <div class="awerack_rg_list_wrp mt-4">
                <!-- <template v-if="researchGroupList">
      <table class="table">
        <thead>
          <th>Date</th>
          <th>Name</th>
          <th>Created By</th>
          <th width="15%" class="text-center">Paper</th>
          <th width="15%" class="text-center">User</th>
          <th class="text-right">Action</th>
        </thead>
          <tbody v-if="researchGroupListResults.length > 0">
            <tr v-for="items in researchGroupListResults">
              <td>{{items.created_at | LocalDateFormat}}</td>
              <td>{{items.name}}</td>
              <td>
                <template v-if="items.created_by">
                  {{items.created_by.first_name}} {{items.created_by.last_name}}
                  <span class="department_of_research_group">{{items.created_by.profile.area_of_work}}</span>
                </template>
              </td>
              <td class="text-center">
                <span class="users_tooltip_wrp" v-if="items.pdf_papers.length > 0">
                  <span>{{items.pdf_papers.length}}</span>
                </span>
                <span v-else>0</span>
              </td>
              <td class="text-center">
                <span class="users_tooltip_wrp" v-if="items.users.length > 0">
                  <span>{{items.users.length}}</span>
                  <ul class="users_tooltip_list">
                    <li v-for="userName in items.users">{{userName.user.first_name}}
                      {{userName.user.last_name}}</li>
                  </ul>
                </span>
                <span v-else>0</span>
              </td>
              <td class="text-right">
                <router-link class="btn btn-info mr-1" title="Info"
                  :to="{name : 'awerackResearchGroupDetails', params: {researchGId: items.id}}"><i
                    class="fa fa-eye"></i></router-link>
                <button class="btn btn-secondary mr-1" v-on:click="updateAwerackRGroupInfoMethod(items.id)"
                  title="Edit"><i class="fa fa-pencil"></i></button>
                <button class="btn btn-danger" v-on:click="removeRGroupMethod(items.id)" title="Delete"><i
                    class="fa fa-trash"></i></button>
              </td>
            </tr>
          </tbody>
          <tbody v-else>
            <tr>
              <td colspan="6" class="text-center">You don't have any research group</td>
            </tr>
          </tbody>
      </table>
    </template> -->
                <div class="rsg_list_box" v-if="researchGroupList">
                    <template v-if="researchGroupListResults.length > 0">
                        <div class="rsg_info_box" v-for="(item, index) in researchGroupListResults" :key="index">
                            <div class="rsg-info_header">
                                <div class="row">
                                    <div class="col">
                                        <h4 class="rsg-title">{{ item.name }}</h4>
                                    </div>
                                    <div class="col-auto">
                                        <h5 class="rsg_publish_date">{{ item.created_at | LocalDateFormat }}</h5>
                                    </div>
                                </div>
                            </div>
                            <div class="rsg-info_body">
                                <div class="rsg_des" v-html="item.topic"></div>
                                <div class="rsg_action_list">
                                    <ul class="usr_list_of_rsg" v-if="item.users.length > 0">
                                        <li><i class="fa fa-users" aria-hidden="true"></i> : </li>
                                        <li v-for="(usr, usrIn) in item.users" :key="usrIn"><span
                                                class="badge badge-primary">{{ usr.user.first_name }}
                                                {{ usr.user.last_name }}</span></li>
                                    </ul>
                                    <ul class="usr_list_of_rsg mt-3" v-if="item.pdf_papers.length > 0">
                                        <li><i class="fa fa-book" aria-hidden="true"></i> :</li>
                                        <li><span style="color:#e3dea6;" class="pl-2">{{ item.pdf_papers.length
                                                }}</span>
                                        </li>
                                    </ul>
                                    <ul class="rsg_action_ul">
                                        <li><router-link
                                                :to="{ name: 'awerackResearchGroupDetails', params: { researchGId: item.id } }">Open</router-link>
                                        </li>
                                        <li @click="updateAwerackRGroupInfoMethod(item.id)">Edit</li>
                                        <li @click="removeRGroupMethod(item.id)">Remove</li>
                                    </ul>
                                </div>
                            </div>
                        </div>
                    </template>
                    <div class="rsg_info_box" v-else>
                        <h6 class="mb-0 no_data text-center">You don't have any research groups</h6>
                    </div>
                </div>
                <div class="fixloader userLoading" v-else>
                    <div class="spinner spinner-1"></div>
                </div>
            </div>
        </div>
        <add-reserach-group v-if="addResearchGroupPopupState"></add-reserach-group>
        <update-reserach-group v-if="updateResearchGroupPopupState"
            v-bind:updateResearchGroupPopupID="updateResearchGroupPopupId"></update-reserach-group>
        <div class="remove_r_group_popup_wrp" v-if="removeRGroupPopupState">
            <div class="remove_r_group_popup_center">
                <div class="remove_r_group_popup_modal">
                    <div class="remove_r_group_popup_header">
                        <h2>Are you sure you want to delete this research group?</h2>
                    </div>
                    <div class="remove_r_group_popup_body text-center">
                        <button class="btn remove_yes_btn" v-on:click="closeRemoveRGroupMethod()">Decline</button>
                        <button class="btn remove_yes_no" v-on:click="removeConfirmRGroupMethod()">Yes, I want</button>
                    </div>
                </div>
            </div>
        </div>
        <access-feature-of-blurb v-if="accessFeaturesOfPackageState"></access-feature-of-blurb>
    </div>
</template>

<script>
/*eslint-disable */
const $ = window.jQuery = require('jquery');

import accessFeaturesForBlurb from '@/components/public/access-features-of-package-popup';
import addReserachGroup from './add-research-group';
import { bus } from '@/main';
import { mapGetters } from 'vuex';
import ppLeftSidebar from '../paperpile-left-sidebar';
import toast from '@/services/toast';
import updateReserachGroup from './update-research-group-detail';

export default {
    name: 'research-group-list',
    components: {
        'pp-left-sidebar': ppLeftSidebar,
        'add-reserach-group': addReserachGroup,
        'update-reserach-group': updateReserachGroup,
        'access-feature-of-blurb': accessFeaturesForBlurb
    },
    props: [],
    data() {
        return {
            researchGroupList: null,
            researchGroupListResults: [],
            nextSteper: '',
            nextPageUrl: '',
            addResearchGroupPopupState: false,
            updateResearchGroupPopupState: false,
            updateResearchGroupPopupId: '',
            removeRGroupPopupState: false,
            removeRGroupPopupId: '',
            selfUserInfo: null,
            accessFeaturesOfPackageState: false
        }
    },
    computed: {
        ...mapGetters([
            'getResearchGroupForAwerackGetters',
            'selfUserInfoGetters',
        ]),
        getSelfUserInfo() {
            this.selfUserInfo = this.$store.getters.selfUserInfoGetters.data;
            return
        },
        getResearchGroupDetails() {
            this.researchGroupList = this.$store.getters.getResearchGroupForAwerackGetters.data;
            return
        },
        getResearchGroupResultsIntialsState() {
            if (this.researchGroupList) {
                this.nextPageUrl = this.researchGroupList.next
                this.nextSteper = this.researchGroupList.next
                this.researchGroupListResults = [].concat(this.researchGroupList.results)
            }
        }
    },
    mounted() {
        this.getSelfUserInfo
        bus.$on('addResearchGroupPopupStateBus', (data) => {
            this.addResearchGroupPopupState = data;
        });
        bus.$on('updateResearchGroupPopupStateBus', (data) => {
            this.updateResearchGroupPopupState = data;
        });
        bus.$on('accessFeaturesOfPackageStateBus', (data) => {
            this.accessFeaturesOfPackageState = data;
        });
    },
    methods: {
        accessFeaturesOfPackagemethod() {
            this.accessFeaturesOfPackageState = true
            document.body.classList.add('body_right_scroll_remove')
        },
        getResearchGroupListAgain() {
            this.$store.dispatch('getResearchGroupListFun')
        },
        openPopupOfAddResearchGroup() {
            this.addResearchGroupPopupState = true
            $('body').addClass('body_right_scroll_remove')
        },
        updateAwerackRGroupInfoMethod(itemId) {
            this.updateResearchGroupPopupState = true
            this.updateResearchGroupPopupId = itemId
            $('body').addClass('body_right_scroll_remove')
        },
        removeRGroupMethod(itemId) {
            this.removeRGroupPopupState = true
            this.removeRGroupPopupId = itemId
            $('body').addClass('body_right_scroll_remove')
        },
        removeConfirmRGroupMethod() {
            this.$store.dispatch('removeAwerackPaperFun', { id: this.removeRGroupPopupId }).then((res) => {
                toast.success(res.data.msg);
                this.closeRemoveRGroupMethod()
                this.getResearchGroupListAgain()
            }).catch((err) => {
            })
        },
        closeRemoveRGroupMethod() {
            this.removeRGroupPopupState = false
            this.removeRGroupPopupId = ''
            $('body').removeClass('body_right_scroll_remove')
        }
    },
    watch: {
        getSelfUserInfo() {
            return this.$store.getters.selfUserInfoGetters;
        },
        getResearchGroupDetails() {
            return this.$store.getters.getResearchGroupForAwerackGetters
        },
        getResearchGroupResultsIntialsState() {
            if (this.researchGroupList) {
                this.nextPageUrl = this.researchGroupList.next
                this.researchGroupListResults = [].concat(this.researchGroupList.results)
            }
        },
        nextSteper(old_val, new_val) {
            if (old_val != '') {
                this.nextPageUrl = old_val
            }
        },
    },
    beforeCreate: function () {
        $('body').addClass('researchfile_body_wrp')
    },
    beforeRouteLeave: function (to, from, next) {
        if (to.name != 'paperPilesPreferences' && to.name != 'paperPiles' && to.name != 'bucketDetails') {
            $('body').removeClass('researchfile_body_wrp');
        }
        next();
    },
}
</script>

<style lang="scss" scoped>
.paperpile_rg_section_wrp {
    font-family: 'MyriadProRegular', 'Lato', sans-serif;
    height: 100%;

    a {
        text-decoration: none;
    }

    &>.row {
        min-height: calc(100dvh - 80px);
    }

    .paperpile_content_header {
        padding: 0px 15px 20px;
        border-bottom: 1px solid rgba(255, 255, 255, 0.05);
        margin: 0 -15px;

        .rfiles_main_heading {
            color: #ffffff;
            font-size: 24px;
            text-transform: uppercase;
            font-weight: bold;
            margin: 0px;
        }

        .rfiles_main_subheading {
            margin: 0;
            font-size: 14px;
            color: #ffd700;
        }

        .rfiles_searchbar {
            position: relative;

            .fa {
                font-size: 18px;
                cursor: pointer;
                color: #c0c0c0;
                position: absolute;
                top: 10px;
                left: 10px;
            }

            &:focus-within {
                .fa {
                    color: #ffd700;
                }
            }

            .form-control {
                background: linear-gradient(-30deg, rgba(37, 44, 84, 0.6) 0%, rgba(0, 0, 0, 0.6) 50%, rgba(38, 38, 38, 0.6) 50%, rgba(44, 44, 84, 0.6) 100%);
                box-shadow: -5px 5px 10px rgba(82, 106, 133, 0.06);
                font-size: 18px;
                color: #ffd700;
                font-family: 'MyriadProRegular', 'Lato', sans-serif;
                border: 1px solid rgba(93, 93, 93, 0.5);
                height: auto;
                width: 280px;
                line-height: 38px;
                padding: 0px 15px 0 40px;
                -webkit-box-shadow: none;
                box-shadow: none;

                &:hover {
                    border-color: #ffd700;
                }

                &:focus {
                    border-color: #ffd700;
                }

                @media only screen and (max-width:769px) {
                    width: 100%;
                }

                &::-moz-placeholder {
                    color: #dfdfdf;
                }

                &::-webkit-input-placeholder {
                    color: #dfdfdf;
                }

                &:focus::-webkit-input-placeholder {
                    font-size: 0px;
                }

                &:focus::-moz-placeholder {
                    font-size: 0px;
                }
            }
        }

        .rfiles_header_right_side {
            display: flex;
            align-items: center;
            margin-bottom: 0px;

            li {
                margin-right: 10px;

                &:last-child {
                    margin-right: 0px;
                }
            }

            .btn-primary {
                cursor: pointer;
                position: relative;
                min-width: 95px;
                -webkit-box-shadow: none !important;
                box-shadow: none !important;
                outline: none !important;
                background: #b41818;
                color: #ffffff;
                border: none;
                border-radius: 3px;
                font-family: 'MyriadProRegular', 'Lato', sans-serif;
                font-size: 18px;
                letter-spacing: 0.5px;

                @media only screen and (max-width:769px) {
                    font-size: 16px;
                    padding: 6px;
                }

                &:hover {
                    background: #87cefa;
                    color: #22292f;
                }
            }
        }
    }
    .paperpile_content_wrp {
        background: rgba(9, 9, 9, 0.95);
        -webkit-box-shadow: -3px 1px 10px rgba(138, 145, 153, 0.05);
        box-shadow: -3px 1px 10px rgba(138, 145, 153, 0.05);
        border-radius: 5px;
        padding: 15px;
        height: 100%;

        @media only screen and (max-width:769px) {
            min-height: calc(100dvh - 90px);
        }
    }

    .paperpile_content_list_inner {
        margin: 0px;

        &>li {
            background: rgba(255, 255, 255, 0.08);
            padding: 10px 15px;
            border-radius: 5px;
            margin-bottom: 10px;

            &:last-child {
                margin-bottom: 0px;
            }

            .rfiles_list_title {
                h3 {
                    font-size: 20px;
                    color: #d6d6d6;
                    margin-bottom: 10px;
                }
            }

            .rfiles_list_action {
                border-top: 1px solid rgba(255, 255, 255, 0.05);
                padding-top: 10px;
            }

            .rfiles_action_list_wrp {
                display: flex;

                li {
                    margin-right: 15px;
                    font-size: 18px;
                    color: #fff8d8;
                    cursor: pointer;

                    &:hover {
                        color: #87cefa;
                    }
                }
            }
        }
    }

    .awerack_rg_list_wrp {
        .table {
            margin-bottom: 0;
            letter-spacing: 0.5px;
            color: #ffffff;
            border-collapse: separate;
            border-spacing: 0 3px;

            thead th {
                border-bottom: 0;
                font-size: 19px;
                padding: 10px 8px;
                font-family: 'MyriadProRegular', 'Lato', sans-serif;
                text-transform: uppercase;
                border-top: 0px;
                transition: all ease 0.5s;
                -webkit-transition: all ease 0.5s;
                -moz-transition: all ease 0.5s;
                background: rgba(228, 233, 237, .1);
                color: #87cefa;
            }

            tbody td {
                color: #ffffff;
                vertical-align: top;
                padding: 25px 8px;
                font-size: 20px;
                font-family: 'MyriadProRegular', 'Lato', sans-serif;
                transition: all ease 0.5s;
                -webkit-transition: all ease 0.5s;
                -moz-transition: all ease 0.5s;
                border-top: 0px;
                background: rgba(228, 233, 237, .1);
            }

            .btn-primary {
                cursor: pointer;
                position: relative;
                min-width: 70px;
                -webkit-box-shadow: none !important;
                box-shadow: none !important;
                outline: none !important;
                background: rgba(255, 255, 255, 0.12);
                color: #ffd700;
                border: none;
                border-radius: 50px;
                font-family: 'MyriadProRegular', 'Lato', sans-serif;
                font-size: 16px;
                padding: 6px 0px;
                line-height: 1;

                &:hover {
                    background: #87cefa;
                    color: #22292f;
                }
            }
        }
    }

    .users_tooltip_wrp {
        position: relative;
        cursor: pointer;

        .users_tooltip_list {
            right: auto;
            position: absolute;
            background: #ffdee3;
            width: 200px;
            padding: 5px 15px;
            cursor: default;
            z-index: 999;
            border-radius: 0;
            font-weight: 600;
            line-height: 1.4;
            font-family: 'MyriadProRegular', 'Lato', sans-serif;
            font-size: 16px;
            color: #000;
            top: calc(100% + 3px);
            border-radius: 2px;
            text-align: left;
            display: none;
            left: -100px;
            z-index: 1000;
            margin: 0px;

            &:before {
                border: solid;
                border-color: #ffdee3 transparent;
                border-width: 12px 12px 0px 0px;
                top: -6px;
                content: "";
                display: block;
                right: auto;
                position: absolute;
                z-index: 1000;
                -webkit-transform: rotate(135deg);
                -moz-transform: rotate(135deg);
                transform: rotate(45deg);
                left: 50%;
            }

            li {
                line-height: 1.1;
                margin-bottom: 3px;

                &:last-child {
                    margin-bottom: 0px;
                }
            }
        }

        &:hover .users_tooltip_list {
            display: block;
        }
    }

    .department_of_research_group {
        color: #fff8d8;
        font-size: 18px;
        display: block;
        line-height: 1.2;
        margin-top: 2px;
    }

    .remove_r_group_popup_wrp {
        position: fixed;
        top: 0;
        bottom: 0;
        background: rgba(0, 0, 0, 0.92);
        left: 0;
        right: 0;
        z-index: 1000;
        display: flex;
        align-items: center;
        justify-content: center;

        .remove_r_group_popup_modal {
            background: #000;
            width: 100%;
            max-width: 500px;
            margin: 0px auto;
            border-radius: 5px;
            padding: 20px 25px;
            font-family: 'MyriadProRegular', 'Lato', sans-serif;
            color: #ffffff;
            -webkit-box-shadow: 0px 0px 13px rgba(255, 213, 0, 0.6);
            box-shadow: 0px 0px 13px rgba(255, 213, 0, 0.6);
        }

        .remove_r_group_popup_header h2 {
            font-size: 20px;
            color: #ffffff;
            font-family: 'MyriadProRegular', 'Lato', sans-serif;
            text-align: center;
            margin: 0 0 30px;
        }

        .remove_yes_btn {
            font-size: 16px;
            background: rgba(255, 18, 18, 0.5);
            color: #fff;
            font-family: 'MyriadProRegular', 'Lato', sans-serif;
            padding: 10px 5px;
            min-width: 100px;
            line-height: 1;
            border-radius: 3px !important;
            outline: none !important;
            box-shadow: none !important;

            &:hover {
                background: #ffe738 !important;
                color: #22292f !important;
            }
        }

        .remove_yes_no {
            font-size: 16px;
            background: rgba(33, 228, 0, 0.5);
            color: #fff;
            font-family: 'MyriadProRegular', 'Lato', sans-serif;
            padding: 10px 5px;
            min-width: 100px;
            line-height: 1;
            margin-left: 15px;
            border-radius: 3px !important;
            outline: none !important;
            box-shadow: none !important;

            &:hover {
                background: #ffe738 !important;
                color: #22292f !important;
            }
        }
    }

    .rsg_list_box {
        .rsg_info_box {
            background: linear-gradient(-30deg, rgba(37, 44, 84, 0.98), rgba(0, 0, 0, 0.98) 50%, rgba(38, 38, 38, 0.98) 0, rgba(44, 44, 84, 0.98));
            padding: 25px;
            border-radius: 20px;
            margin-bottom: 10px;
            border: 1px solid rgba(93, 93, 93, 0.5);

            .rsg-title {
                font-size: 22px;
                color: #ffffff;
                margin: 0px;
            }

            .rsg_publish_date {
                margin: 0;
                color: #ffe9e9;
                font-size: 16px;
            }

            .rsg-info_header {
                margin-bottom: 10px;
            }

            .no_data {
                text-align: center;
                font-family: 'MyriadProRegular', 'Lato', sans-serif;
                font-size: 18px;
                color: #ffffff;
                padding: 50px 15px;
            }
        }

        .rsg_action_list {
            border-top: 1px solid rgba(255, 255, 255, 0.05);
            padding-top: 15px;
            position: relative;
            margin-top: 15px;

            ul {
                margin: 0px;
                display: flex;
                align-items: center;

                li {
                    margin-right: 15px;
                    font-size: 17px;
                    color: #6e6e6e;

                    a {
                        color: inherit;
                        text-decoration: none;
                    }

                    &:last-child {
                        margin-right: 0px;
                    }
                }

                &.rsg_action_ul {
                    margin-top: 12px;

                    li {
                        cursor: pointer;
                        margin-right: 15px;
                        font-size: 16px;
                        color: #ffe9e9;
                        cursor: pointer;
                        border: 1px solid #ffe9e9;
                        padding: 6px 20px 8px;
                        line-height: 1;
                        border-radius: 30px;

                        &:hover {
                            background: #ffe9e9;
                            color: #000000;
                        }
                    }
                }

                &.usr_list_of_rsg {
                    .badge {
                        background: #261139;
                        padding:6px 15px 8px;
                        font-weight: normal;
                        line-height: 1;
                        border-radius: 20px;
                        border: none;
                        font-size: 16px;
                        color: #a560e8;
                        margin: 0;
                    }

                    .fa {
                        color: #ffe9e9;
                    }
                }
            }
        }
    }
}

@media only screen and (max-width:769px) {
    .awerack_rg_list_wrp {
        .table {
            display: block;

            thead {
                display: none;
            }

            tbody {
                display: block;

                tr {
                    display: block;
                    background: rgba(228, 233, 237, 0.1);
                    margin-bottom: 1px;
                    padding: 15px 0;
                }

                td {
                    display: block;
                    text-align: left !important;
                    height: auto !important;
                    padding: 5px 10px !important;
                    background: none !important;
                }
            }
        }
    }
}
</style>